import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  NavItem,
  UncontrolledDropdown } from 'reactstrap';
import ContactModal from '../pages/consumer/ContactModal';

class ConsumerHeader extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdown: false,
      modal: false
    };
  }

  toggle = () => {
    this.setState({ dropdown: !this.state.dropdown });
  }

  handleModal = (e) => {
    e.preventDefault();
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;

    return (
      <div>
        <Navbar light expand="lg" className="consumer-header">
          <NavbarBrand className="text-hide" href="/">LendingUSA Customer Portal</NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.dropdown} navbar>
            <Nav navbar className="w-100">
              <div className="lu-main-nav d-lg-flex ml-lg-auto">
                <NavItem>
                  <NavLink to="/consumer/dashboard" className="nav-link">Dashboard</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to="/consumer/loans" className="nav-link">My Loans</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to="/consumer/documents" className="nav-link">Documents</NavLink>
                </NavItem>
              </div>
              <div className="lu-second-nav d-lg-flex ml-lg-auto">
                <NavItem>
                  <NavLink to="/" className="nav-link" title="Contact Us" onClick={this.handleModal}>
                    Contact Us
                  </NavLink>
                </NavItem>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Account
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem tag="a" href="/consumer/settings">Account Settings</DropdownItem>
                    <DropdownItem tag="a" href="/">Sign Out</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </Nav>
          </Collapse>
        </Navbar>

        <ContactModal isOpen={modal} toggle={this.handleModal} />
      </div>
    );
  }
}

export default ConsumerHeader;
